import styled from 'styled-components';

export const PersonContainer = styled.div.attrs(props => ({
  'data-sound-action': 'click',
}))`
  display: flex;
  margin: ${props => props.margin || null};
`;
